<!-- Header -->
<app-header class="app-header"></app-header>

<!-- Side Navbar -->
<div class="wrp-main menu-container">
  <mat-sidenav-container class="sidenav-container" autosize>
    <mat-sidenav #sidenav class="sidenav-data" mode="side" opened="true">
      <mat-nav-list class="button-group" (click)="onButtonGroupClick($event)">
        <div class="sidenav-header">
          <div class="yokahu-logo">
            @if (isShowing) {
              <img mat-card-sm-image [src]="logoPath$ | async" alt=""
                [class.yokahu-logo-img]="isDefaultLogo" (error)="onImgError($event)"
                (load)="onMainLogoLoad($event)"
                [class.not-default-logo]="!isDefaultLogo">
            }
            @if (!isShowing) {
              <img mat-card-sm-image [src]="smallLogoPath$ | async" alt=""
                (load)="onSmallLogoLoad($event)"
                [class.logo-small]="isDefaultSmallLogo" (error)="onSmallImgError($event)"
                [class.not-default-logo-small]="!isDefaultSmallLogo">
            }
          </div>
          <button type="button" class="sidenav-toggle-btn" (click)="openclose(0)"
            [matTooltip]="isShowing ? 'Collapse menu' : 'Expand menu'" matTooltipPosition="right">
            <mat-icon>{{ isShowing ? 'chevron_left' : 'chevron_right' }}</mat-icon>
          </button>
        </div>
        <div class="menu-scroll-list">
          <mat-list-item [ngClass]="{'active': getActiveIndex == 1}" (click)="search(1)"
            [matTooltip]="'Search'" [matTooltipDisabled]="isShowing" matTooltipPosition="right">
            <mat-icon mat-list-icon>image_search</mat-icon>
            @if (isShowing) {
              <span class="full-width" [ngClass]="{'expanded' : isShowing }">Search</span>
            }
          </mat-list-item>
          <mat-list-item [ngClass]="{'active': getActiveIndex == 7}" (click)="clients(7)"
            [matTooltip]="'Clients'" [matTooltipDisabled]="isShowing" matTooltipPosition="right">
            <mat-icon mat-list-icon>people</mat-icon>
            @if (isShowing) {
              <span class="full-width" [ngClass]="{'expanded' : isShowing }">Clients</span>
            }
          </mat-list-item>
          <mat-list-item (click)="newRequest(2)" [ngClass]="{'active': getActiveIndex == 2}"
            [matTooltip]="router.url.includes('edit-request') ? 'Edit request' : 'New request'"
            [matTooltipDisabled]="isShowing" matTooltipPosition="right">
            <mat-icon mat-list-icon>edit</mat-icon>
            @if (isShowing) {
              <span class="full-width">{{router.url.includes('edit-request') ? 'Edit' : 'New'}}
              request</span>
            }
          </mat-list-item>
          <mat-list-item (click)="requests(3)" [ngClass]="{'active': getActiveIndex == 3}"
            [matTooltip]="'Requests'" [matTooltipDisabled]="isShowing" matTooltipPosition="right">
            <mat-icon mat-list-icon>text_snippet</mat-icon>
            @if (isShowing) {
              <span class="full-width">Requests</span>
            }
          </mat-list-item>
          <mat-list-item (click)="nonBindingIndication(4)" [ngClass]="{'active': getActiveIndex == 4}"
            [matTooltip]="'Non-binding indications'" [matTooltipDisabled]="isShowing" matTooltipPosition="right">
            <mat-icon mat-list-icon>done_all</mat-icon>
            @if (isShowing) {
              <span class="full-width">Non-binding indications</span>
            }
          </mat-list-item>
          <mat-list-item (click)="quoteRequested(8)" [ngClass]="{'active':getActiveIndex == 8}"
            [matTooltip]="'Quote Requested'" [matTooltipDisabled]="isShowing" matTooltipPosition="right">
            <mat-icon mat-list-icon>hourglass_empty</mat-icon>
            @if (isShowing) {
              <span class="full-width">Quote Requested</span>
            }
          </mat-list-item>
          <mat-list-item (click)="quote(5)" [ngClass]="{'active':getActiveIndex == 5}"
            [matTooltip]="'Quotes'" [matTooltipDisabled]="isShowing" matTooltipPosition="right">
            <mat-icon mat-list-icon>call_merge</mat-icon>
            @if (isShowing) {
              <span class="full-width">Quotes</span>
            }
          </mat-list-item>
          <mat-list-item (click)="bind(6)" [ngClass]="{'active': getActiveIndex == 6}"
            [matTooltip]="'Bound'" [matTooltipDisabled]="isShowing" matTooltipPosition="right">
            <mat-icon mat-list-icon>verified_user</mat-icon>
            @if (isShowing) {
              <span class="full-width">Bound</span>
            }
          </mat-list-item>
          <mat-list-item (click)="underwriting(9)" [ngClass]="{'active': getActiveIndex == 9}"
            [matTooltip]="'Underwriting'" [matTooltipDisabled]="isShowing" matTooltipPosition="right">
            <mat-icon mat-list-icon>rate_review</mat-icon>
            @if (isShowing) {
              <span class="full-width">Underwriting</span>
            }
          </mat-list-item>
          <mat-list-item (click)="cancelled(10)" [ngClass]="{'active': getActiveIndex == 10}" [matTooltip]="'Cancelled'"
            [matTooltipDisabled]="isShowing" matTooltipPosition="right">
            <mat-icon mat-list-icon>cancel</mat-icon>
            @if (isShowing) {
            <span class="full-width">Cancelled</span>
            }
          </mat-list-item>
        </div>
      </mat-nav-list>
      <mat-nav-list> </mat-nav-list>
    </mat-sidenav>
    <div class="right-content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-container>
</div>